module.exports = __webpack_public_path__ + "static/media/React-Native.d22d60f5.png";